import {
  ADD_NEW_LIST_SUCCESS,
  COPY_LIST_SUCCESS,
  DELETE_LIST_ITEM_SUCCESS,
  GET_EXPERIENCES_LIST_SUCCESS,
  GET_EXPERIENCES_SUCCESS,
  GET_LIST_FEATURE,
  GET_LIST_FEATURE_FAILED,
  GET_LIST_FEATURE_SUCCESS,
  GET_LIST_ITEM_CLICKS_SUCCESS,
  GET_LIST_ITEM_SUCCESS,
  GET_LIST_OF_LISTS,
  GET_LIST_OF_LISTS_FAILED,
  GET_LIST_OF_LISTS_SUCCESS,
  HIDE_COPY_LIST_MODAL,
  HIDE_DELETE_LIST_MODAL,
  HIDE_LIST_ITEM_POPUP,
  OPEN_COPY_LIST_MODAL,
  OPEN_DELETE_LIST_MODAL,
  OPEN_LIST_ITEM_POPUP,
  RESET_LIST_FEATURE,
  RESET_LIST_ITEM,
  RESET_LIST_ITEM_CLICKS,
  RESET_LIST_OF_LISTS,
  UPDATE_LIST_FEATURE_SUCCESS,
  UPDATE_LIST_ORDER_SUCCESS,
  UPDATE_LIST_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  isListItemPopupOpen: false,
  listFeature: null,
  listOfLists: [],
  isCopyListModalOpen: false,
  experiences: [],
  experiencesList: [],
  isDeleteListModalOpen: false,
  listItem: null,
  listItemClicks: null,
  loading: false,
  listLoading: false,
  destroyed: false,
  listDestroyed: false,
}

const List = (state = INIT_STATE, action) => {
  switch (action.type) {
    case OPEN_LIST_ITEM_POPUP:
      return {
        ...state,
        isListItemPopupOpen: true,
      }
    case HIDE_LIST_ITEM_POPUP:
      return {
        ...state,
        isListItemPopupOpen: false,
      }
    case ADD_NEW_LIST_SUCCESS:
      if (action.payload.menu_feature === 1) {
        return {
          ...state,
          listFeature: action.payload,
        }
      } else {
        return {
          ...state,
          listOfLists: [...state.listOfLists, action.payload],
        }
      }
    case GET_LIST_OF_LISTS:
      return {
        ...state,
        listLoading: true,
        listDestroyed: false,
      }
    case GET_LIST_OF_LISTS_SUCCESS:
      return {
        ...state,
        listOfLists: action.payload,
        listLoading: false,
      }
    case GET_LIST_OF_LISTS_FAILED:
      return {
        ...state,
        listLoading: false,
      }
    case DELETE_LIST_ITEM_SUCCESS:
    case UPDATE_LIST_FEATURE_SUCCESS:
    case UPDATE_LIST_ORDER_SUCCESS:
      return {
        ...state,
        listOfLists: action.payload,
      }
    case OPEN_COPY_LIST_MODAL:
      return {
        ...state,
        isCopyListModalOpen: true,
      }
    case HIDE_COPY_LIST_MODAL:
      return {
        ...state,
        isCopyListModalOpen: false,
      }
    case GET_EXPERIENCES_SUCCESS:
      return {
        ...state,
        experiences: action.payload,
      }
    case GET_EXPERIENCES_LIST_SUCCESS:
      return {
        ...state,
        experiencesList: action.payload,
      }
    case GET_LIST_FEATURE:
      return {
        ...state,
        loading: true,
        destroyed: false,
      }
    case GET_LIST_FEATURE_SUCCESS:
      return {
        ...state,
        listFeature: action.payload,
        loading: false,
      }
    case GET_LIST_FEATURE_FAILED:
      return {
        ...state,
        loading: false,
      }
    case COPY_LIST_SUCCESS:
      if (action.payload.menu_feature === 1) {
        return {
          ...state,
          listFeature: action.payload,
        }
      } else {
        return state
      }
    case RESET_LIST_FEATURE:
      return {
        ...state,
        listFeature: null,
        loading: false,
        destroyed: true,
      }
    case UPDATE_LIST_SUCCESS:
      if (action.payload.length === 0) {
        return state
      } else {
        return {
          ...state,
          listOfLists: action.payload,
        }
      }
    case OPEN_DELETE_LIST_MODAL:
      return {
        ...state,
        isDeleteListModalOpen: true,
      }
    case HIDE_DELETE_LIST_MODAL:
      return {
        ...state,
        isDeleteListModalOpen: false,
      }
    case RESET_LIST_OF_LISTS:
      return {
        ...state,
        listOfLists: [],
        listLoading: false,
        listDestroyed: true,
      }
    case GET_LIST_ITEM_SUCCESS:
      return {
        ...state,
        listItem: action.payload,
      }
    case RESET_LIST_ITEM:
      return {
        ...state,
        listItem: null,
      }
    case GET_LIST_ITEM_CLICKS_SUCCESS:
      return {
        ...state,
        listItemClicks: action.payload,
      }
    case RESET_LIST_ITEM_CLICKS:
      return {
        ...state,
        listItemClicks: null,
      }
    default:
      return state
  }
}

export default List
